import React from "react";
import styled from "styled-components";
import useState from "../../Hooks/useState";

import Staking from "./Staking";
import StakingList from "./List";

const Container = () => {
  const phase = useState(0);

  return (
    <>
      {phase.state === 0 && <Staking phase={phase} />}
      {phase.state === 1 && <StakingList phase={phase} />}
    </>
  );
};

export default Container;
